<div class="line-header">
    <div class="container">
        <div class="row row-cols-auto justify-content-end align-items-center text-end">
            <!-- Inicia seach -->
    <!--         <app-search-bar></app-search-bar> -->
            <!-- Termina search -->
            <a href="https://www.facebook.com/ceplan/" target="_blank">
                <i class="icon-header fa fa-facebook fa-3"></i>
            </a>
            <a href="https://twitter.com/CEPLAN2050" target="_blank">
                <i class="icon-header fa fa-twitter fa-3"></i>
            </a>
            <a href="https://www.youtube.com/user/CanalCeplan" target="_blank">
                <i class="icon-header fa fa-youtube fa-3"></i>
            </a>
            <a class="dropdown-toggle" data-bs-toggle="dropdown" href="#">
                <i class="icon-header fa fa-user fa-3"></i>
            </a>
            <ul class="dropdown-menu text-center" role="menu">
                <li *ngIf="!isLoggedIn">
                    <a routerLink="login" class="underline">
                        Ingresar <i class="fa fa-unlock fa-3" aria-hidden="true"></i>
                    </a>
                </li>
                <li class="divider"></li>
                <ng-container *ngIf="isLoggedIn && IO">
                    <li>
                        <a routerLink="adm/{{firstUrlLogged}}">
                            Panel de control <i class="fa fa-window-restore" aria-hidden="true"></i>
                        </a>
                    </li>
                </ng-container>
                <ng-container *ngIf="isLoggedIn && IA">
                    <li>
                        <a routerLink="encuesta">
                            Adm. encuestas <i class="fa fa-window-restore" aria-hidden="true"></i>
                        </a>
                    </li>
                </ng-container>
                <li class="divider"></li>
                <li *ngIf="isLoggedIn">
                    <a (click)="logOut()">
                        Cerrar sesión <i class="fa fa-lock" aria-hidden="true"></i>
                    </a>
                </li>
            </ul>
            <a class="icon-header text-center" *ngIf="isLoggedIn">{{usuario}}</a>
        </div>
    </div>
</div>

<div class="container container-head">
    <nav class="navbar navbar-expand-sm" style="padding-left: 1rem; padding-right: 1rem;">
        <div class="nav-mob col-sm-6">
            <a class="text-end" routerLink="/">
                <img class="img-obs" src="assets/img/obs-small.webp" alt="Observatorio CEPLAN">
            </a>
        </div>
        <div class="col-sm-6">
            <div class="nav-mob text-end">
                <a class="a-img-pcm">
                    <img class="img-fluid img-pcm" src="assets/img/logo-peru.svg" alt="Logo PCM">
                </a>
            </div>
        </div>
    </nav>
    <nav class="navbar navbar-expand-sm navbar-fuse">
        <div class="col-sm-12">
            <ul class="navbar-nav justify-content-center">
                <li class="nav-item li-nav" *ngFor="let o of m1">
                    <a class="nav-link a-nav-1" *ngIf="o.route && id_n>0" routerLinkActive="active1"
                        routerLink="{{o.route}}">{{o.title}}</a>
                    <a class="nav-link a-nav-1" *ngIf="o.external" routerLinkActive="active1" href="{{o.external}}"
                        target="_blank">{{o.title}}</a>
                </li>
            </ul>
        </div>
    </nav>
</div>

<nav class="navbar navbar-expand-lg navbar-light custom-menu">
    <!-- Parte izquierda: logo con padding -->
    <a class="nav-pc navbar-brand" routerLink="inicio" style="padding-left: 1rem;">
        <img class="img-pcm pl-2" src="assets/img/obs-small.webp" alt="Observatorio CEPLAN">
    </a>
    <!-- Parte derecha: boton del toggler -->
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
        aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
    </button>
    <!-- Contenedor fluido para el menú desplegable -->
    <div class="container-fluid" style="background-color: #3B69AE;">
        <div class="container">
            <div class="collapse navbar-collapse justify-content-center" id="navbarNav">
                <ul class="navbar-nav">
                    <li class="nav-item-fuse nav-item " *ngFor="let o of m1">
                        <a class="nav-link a-nav-2" *ngIf="o.route && id_n>0" routerLinkActive="active2"
                            routerLink="{{o.route}}" hideCollapseOnClick>{{o.title}}</a>
                        <a class="nav-link a-nav-2" *ngIf="o.external" routerLinkActive="active2" href="{{o.external}}"
                            target="_blank">{{o.title}}</a>
                    </li>
                    <ng-container *ngFor="let p of m2">
                        <!-- Mostrar solo para dispositivos grandes -->
                        <li class="nav-item" *ngIf="esDispositivoGrande">
                            <a class="nav-link a-nav-2" routerLinkActive="active2" [routerLink]="p.route">
                                {{p.title}}
                            </a>
                            <ul class="nav flex-column submenu" *ngIf="p.submenus && p.submenus.length > 0">
                                <li class="nav-item nav_submenu sub-menu-item" *ngFor="let submenu of p.submenus">
                                    <a class="nav-link" routerLinkActive="active2" routerLink="{{submenu.route}}">
                                        <span class="underline"
                                            style="color: white !important;">{{submenu.title}}</span>
                                    </a>
                                </li>
                            </ul>
                        </li>
                        <!-- Mostrar solo para dispositivos móviles -->
                        <li class="nav-item-fuse nav-item" *ngIf="!esDispositivoGrande" [class.selected]="p.isSelected">
                            <a class="nav-link a-nav-2" [routerLink]="p.route">
                                {{p.title}}
                            </a>
                        </li>
                    </ng-container>
                </ul>
            </div>
        </div>
    </div>
</nav>